import React, { useRef, useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import InfiniteScroller from 'react-infinite-scroller'

const style = theme => ({
	root: {
		height: '45vh',
		overflow: 'auto',
		paddingRight: theme.scrollSize,
	}
})


function RadioListInfiniteScroller({
	classes,
	children,
	size,
	maxSize,
	page,
	loadMore,
}) {
	const containerRef = useRef();
	const [hasMore, setHasMore] = useState(false)
	const threshold = 200;

	useEffect(() => {
		if (!hasMore) {
			setTimeout(() => {
				setHasMore(maxSize > size);
			}, 500)
		}
		// eslint-disable-next-line
	}, [size])

	const load = (page) => {
		setTimeout(() => {
			if (hasMore) {
				setHasMore(false);
				loadMore();
			}
		}, 500)
	}

	return (
		<div className={classes.root} ref={containerRef}>
			<InfiniteScroller
				initialLoad={true}
				pageStart={page}
				loadMore={load}
				hasMore={hasMore}
				loader={'LOADING...'}
				useWindow={false}
				threshold={threshold}
				getScrollParent={() => containerRef.current}
			>
				{children}
			</InfiniteScroller>
		</div>
	)
}

RadioListInfiniteScroller.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(RadioListInfiniteScroller);